document.addEventListener('DOMContentLoaded', function() {
  const lenis = new Lenis();

  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);
  
  let staggerOpacity = (slides) => {
      if (slides && slides.length > 1) {
          // Exclude the first slide and extract the element from each slide
          let slideElements = slides.slice().map(slide => slide.element);
          gsap.fromTo(slideElements,
              { opacity
                  : 0 },
              { 
                  opacity: 1,
                  duration: 2,
                  stagger: 0.5,
                  scrollTrigger: {
                      trigger: document.querySelector('.fr-slider'),
                      start: 'top bottom',
                      once: true,
                      end: 'center 50%',
                      scrub: true
                  }
              }
          );
      }
  }

  const frSlider = document.querySelector('.fr-slider');
  if (frSlider) {
      const flkty = new Flickity( frSlider, {
          cellAlign: 'left',
          wrapAround: true,
          groupCells: false,
          pageDots: false,
          autoPlay: 3000,
          on: {
              ready: function() {
                  staggerOpacity(this.cells, this.slides.length );
              }
          }
      });
  }

  // Moved fade-in GSAP animation here
  gsap.set(".product-item__image", { opacity: 0 });

  gsap.to(".product-item__image", {
    opacity: 1,
    delay:    1,
    duration: 0.5,
    ease: "power1.inOut"
  });

  // Promotion Cards Animation
  let cardWrapper = document.querySelectorAll('.fr-card__wrapper');
  gsap.fromTo(cardWrapper, {
      opacity: 0
  }, {
      opacity: 1,
      duration: 1,
      stagger: 0.5,
  });

  // Blob Animation
  const blob = document.querySelectorAll('.blob');
  let targets = gsap.utils.toArray(blob);
  let firstChildBottom = 10;
  gsap.fromTo(targets[0],{
      yPercent: 100,
      xPercent: 0
  },{
      duration: 10,
      xPercent: Math.floor(Math.random() * 100),
      yPercent: Math.floor(Math.random() * 100),
      scaleX: 1,
      scaleY: 1.5,
      rotate: 360,
      repeat: -1,
      yoyo: true,
      ease: 'none'
  });
  gsap.fromTo(targets[1],{
      yPercent: 0,
      xPercent: 0
  },{
      duration: 10,
      xPercent: Math.floor(Math.random() * 100),
      yPercent: Math.floor(Math.random() * 100),
      scaleX: 1,
      scaleY: 1.2,
      rotate: 360,
      repeat: -1,
      repeatDelay: 2,
      yoyo: true,
      ease: 'none'
  });



  // Image Hotspots
  const imageHotspotsContainer = document.querySelector('.fr-image-hotspots');
  if (imageHotspotsContainer) {
      let hotSpotsImage = imageHotspotsContainer.querySelector('.image-with-hotspots figure');
      let singleSwatch = imageHotspotsContainer.querySelector('.fr-custom-image--section');
      let mq = gsap.matchMedia();
      let tl = gsap.timeline();
      tl.fromTo(hotSpotsImage, {
          width: '200%'
      }, {
          duration: 1,
          width: '100%',
          scrollTrigger: {
              trigger: imageHotspotsContainer,
              start: 'top 80%',
              end: '80% 80%',
              scrub: true,
              markers: false,

              onUpdate: self => {
                  if (self.progress === 1) {
                      document.querySelector('.image-hotspots').classList.add('active');
                  }
              }
          },
          ease: 'power2.inOut'
      });

      gsap.fromTo(singleSwatch, {
          right: 0
      }, {
          duration: 1,
          right: '20%',
          ease: 'power2.inOut',
          delay: 1,
          scrollTrigger: {
              trigger: imageHotspotsContainer,
              start: 'top bottom',
              end: '80% 80%',

              scrub: true,
          }
      });

      let typewriter = document.querySelectorAll('.fr-custom-text--section  h2');
      function wrapLetters(el) {
          Array.from(el.childNodes).forEach(child => {
              if (child.nodeType === Node.TEXT_NODE) {
                  const frag = document.createDocumentFragment();
                  child.textContent.split("").forEach(char => {
                      const span = document.createElement("span");
                      span.className = "letter";
                      span.textContent = char;
                      frag.appendChild(span);
                  });
                  child.parentNode.replaceChild(frag, child);
              } else if (child.nodeType === Node.ELEMENT_NODE) {
                  wrapLetters(child);
              }
          });
      }

      typewriter.forEach(el => wrapLetters(el));
      let typewritterTl = gsap.timeline();
      let letters = document.querySelectorAll(".letter");

      mq.add(
        {
          isMobile: "(max-width: 767px)",
          isDesktop: "(min-width: 768px)",
        },
        (context) => {
          const isMobile = context.conditions.isMobile;
      
          context.add(() => {
            typewritterTl.from(letters, {
              opacity: 0,
              duration: 1,
              stagger: letters.length,
              scrollTrigger: {
                trigger: typewriter,
                start: isMobile ? 'top bottom' : '40% 80%',
                end: isMobile ? '20% 50%' : 'top 40%',
                scrub: true,
                markers: false
              }
            });
          });
        }
      );
  }


const videoTl = gsap.timeline();
const fullBleedVideo = document.querySelector('.fr-video--full-width');
const mq = gsap.matchMedia();



mq.add("(min-width: 800px)", () => {
  

  
  videoTl.fromTo(fullBleedVideo,{
      clipPath: 'inset(10%)',
  
  },
  {
    clipPath: 'inset(0%)',
      duration: 1,
      ease: 'power2.inOut',
      scrollTrigger: {
          trigger: fullBleedVideo,
          start: 'top 90%',
          end: 'center 60%',
          scrub: true
      }     
  }
  )
  
 

});

let observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      fullBleedVideo.play();
      console.log('playing');
    } else {
      fullBleedVideo.pause();
      console.log('paused');
    }
  });
}, {
  threshold: 0.5 // Trigger when 50% of the video is in the viewport
});

if (fullBleedVideo) {
observer.observe(fullBleedVideo);
}

  

// GSAP clip-path animation for #element-main-collection-banner__fr .card__image
const clipTarget = document.querySelector('#element-main-collection-banner__fr .card__image');
if (clipTarget && window.innerWidth > 768) {
  gsap.set(clipTarget, {
    clipPath: 'inset(0% 0% 0% 0%)'
  });

  gsap.to(clipTarget, {
    clipPath: 'inset(20% 10% 20% 35% round 1rem 1.5rem 1.5rem 1rem)',
    duration: 4,
    ease: 'power2.inOut',
    delay: 1
  });
}

gsap.registerPlugin(ScrollTrigger);
let loyaltyIcons = document.querySelectorAll('.loyalty-icon-text-block');
if(loyaltyIcons){
  gsap.utils.toArray(loyaltyIcons).forEach((icon, index) => {
      gsap.fromTo(icon, {
          y: 100,
          opacity: 0
      },{
      scrollTrigger: {
          trigger: icon,
          start: 'top 90%',
          markers: false,
      },
          y: 0,
          opacity: 1,
      });
  });
}


let productsCarousel = document.querySelector('#main-collection-product-grid');
if(productsCarousel){
  let collectionCarousel = new Flickity(productsCarousel, {
    cellAlign: 'left',
    wrapAround: false,
    watchCSS: true,
    groupCells: false,
  });
} 

let textMediaCarousel = document.querySelector('.template-collection .fr-media-with-text-cards--container');
let mediaCarousel = new Flickity(textMediaCarousel, {
  cellAlign: 'center',
  wrapAround: true,
  watchCSS: true,
  groupCells: false,
  
});
 


const fullWidthBannerWithText = document.querySelector('.fr-media-with-text-wrapper_image');
if(fullWidthBannerWithText){
  let mq = gsap.matchMedia();
  let tl = gsap.timeline();
  mq.add("(min-width: 768px)", () => {
    tl.fromTo(fullWidthBannerWithText, {
      clipPath: 'inset(0% 0% 0% 0% round 0 0 0 0)',
      scale: 1.1,
    }, {
      clipPath: 'inset(0% 5% 0% 5% round 1.5rem 1.5rem 1.5rem 1.5rem)',
      scale: 1,
      duration: 1,
      ease: 'power2.inOut',
      scrollTrigger: {
        trigger: fullWidthBannerWithText,
        start: 'top 90%',
        end: 'center 60%',
        scrub: true,
        markers: false,
      },
    });
  });
  
}
const slideshowAnimationContracts = document.querySelector('.fr-animation-contracts');
if(slideshowAnimationContracts){
  let mq = gsap.matchMedia();
  let tl = gsap.timeline();
  mq.add("(min-width: 768px)", () => {
    tl.fromTo(slideshowAnimationContracts, {
      clipPath: 'inset(0% 0% 0% 0% round 0 0 0 0)',
    }, {
      clipPath: 'inset(10% round 1rem)',
      duration: 1,
      ease: 'power2.inOut',
      scrollTrigger: {
        trigger: slideshowAnimationContracts,
        start: 'top 90%',
        end: 'center 60%',
        scrub: true,
        markers: false,
      },
    });
  });
  
}
const slideshowAnimationExpands = document.querySelector('.fr-animation-expands');


if(slideshowAnimationExpands){
  let mq = gsap.matchMedia();
  let tl = gsap.timeline();
  mq.add("(min-width: 768px)", () => {
    tl.fromTo(slideshowAnimationExpands, {
      clipPath: 'inset(10% round 1rem)',
      
    }, {
      clipPath: 'inset(10% 10% 10% 10% round 1rem 1rem 1rem 1rem)',
      duration: 1,
      ease: 'power2.inOut',
      scrollTrigger: {
        trigger: slideshowAnimationExpands,
        start: 'top 90%',
        end: 'bottom 90%',
        scrub: true,
        markers: false,
      },
    });
  });
  
}
});


// Hide cart count if 0
function updateCartCountVisibility() {
  document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
    elm.style.display = elm.textContent.trim() === '0' ? 'none' : '';
  });
}
updateCartCountVisibility();
document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
  new MutationObserver(updateCartCountVisibility).observe(elm, {
    childList: true,
    characterData: true,
    subtree: true
  });
});
